import { useEffect, useMemo, useState } from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "../firebase";
import { clearMagicLinkLocalState, getStoredMagicLinkEmail, getStoredSid } from "../auth/magicLink";

function getSidFromUrl() {
  const url = new URL(window.location.href);
  return url.searchParams.get("sid") || "";
}

export default function FinishSignIn() {
  const [status, setStatus] = useState("Checking sign-in link…");
  const [canRetry, setCanRetry] = useState(false);
  const sidInUrl = useMemo(getSidFromUrl, []);

  useEffect(() => {
    (async () => {
      try {
        const href = window.location.href;

        if (!isSignInWithEmailLink(auth, href)) {
          setStatus("This link is not a valid sign-in link.");
          setCanRetry(true);
          return;
        }

        const sidLocal = getStoredSid();
        if (!sidInUrl || sidInUrl !== sidLocal) {
          setStatus(
            "This sign-in link was requested on a different device/browser. For security, please request a new link on this device."
          );
          setCanRetry(true);
          return;
        }

        const email = getStoredMagicLinkEmail();
        if (!email) {
          setStatus("We can't find the email used on this device. Please request a new sign-in link.");
          setCanRetry(true);
          return;
        }

        setStatus("Signing you in…");
        await signInWithEmailLink(auth, email, href);

        // One-time local cleanup to prevent accidental reuse
        clearMagicLinkLocalState();

        setStatus("Signed in. Redirecting…");
        window.location.replace("/");
      } catch (e) {
        console.error(e);
        setStatus("Sign-in failed. Please request a new link.");
        setCanRetry(true);
      }
    })();
  }, [sidInUrl]);

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2, bgcolor: "#F5F7F5" }}>
      <Card sx={{ width: "min(520px, 100%)", borderRadius: 4 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" fontWeight={700}>
            Finishing sign-in
          </Typography>
          <Typography sx={{ mt: 1, color: "text.secondary" }}>{status}</Typography>

          {canRetry && (
            <Button sx={{ mt: 3 }} variant="contained" onClick={() => (window.location.href = "/login")}>
              Back to sign-in
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}